module.exports = __webpack_public_path__ + "media/images/tyre-closeup-14f9a56761f22a99e678b026df93402e.jpg";